import React from "react";

import CodeEditor from "../../../../../components/elements/CodeEditor";

import {
    WORKSPACE_TEMPLATES
}
    from "../../../../../utils/workspaceTemplates";

export default function WorkspaceEditorsManager({

                                                    workspace,

                                                    editors,

                                                    path,

                                                    updateAtPath

                                                }){

    const template =
        (WORKSPACE_TEMPLATES[workspace.type] || []).find(
            t => t.value === workspace.template
        );

    if (!template) {
        return <div>Invalid workspace template: {workspace.template}</div>;
    }


    return(

        <div className="grid gap-8">

            {

                template.slots.map((slot,index)=>{

                    const editor =

                        editors[index];

                    return(

                        <details
                            key={slot}
                            className="border rounded-md bg-white"
                        >
                            <summary className="cursor-pointer p-4 font-semibold">
                                Starter Code ({slot})
                            </summary>

                            <div className="p-4">
                                <CodeEditor
                                    language={
                                        slot === "main"
                                            ? workspace.template.split("_")[0]
                                            : slot
                                    }
                                    value={editor?.starterCode || ""}
                                    onChange={(value) =>
                                        updateAtPath(
                                            [...path, index, "starterCode"],
                                            value
                                        )
                                    }
                                />
                            </div>
                        </details>

                    );

                })

            }

        </div>

    );

}